'use client';

import { useTranslation } from 'react-i18next';

/**
 * Reminder, next to any figure that describes our investor database, that the
 * database is the floor: every SendVC run also searches the web for more
 * investors. Without it a small sector count reads as "that is all you get".
 */
export function DbFloorNote({ className = '' }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <aside className={`rounded-xl border border-primary-100 bg-primary-50 p-5 ${className}`}>
      <p className="text-sm font-semibold text-gray-900">{t('pageContent.dbFloor.title')}</p>
      <p className="mt-1 text-sm text-gray-700">{t('pageContent.dbFloor.body')}</p>
    </aside>
  );
}
